import { Locale, K } from "../constants";

const locale: Locale = {
  [K.YESTERDAY]: "昨天",
  [K.TODAY]: "今天",
  [K.FUTURE_AFTER]: "{{time}}后",
  [K.FORMAT_SHORT]: "MMMD日 ah:mm",
  [K.FORMAT_SHORT_DAY]: "MMMD日 HH:mm",
  [K.MONTHS]: "个月",
  [K.HOURS]: "小时",
  [K.SECONDS]: "秒",
  [K.MILL_SECONDS]: "毫秒",
  [K.DAYS]: "天",
  [K.MINUTES]: "分钟",
  [K.TEN_HOURS_TEN_MINUTES_TEST]: "0.2 秒",
  [K.ONE_TWO_SECONDS]: "1.2 秒",
  [K.OO_TWO_ONE_SECONDS]: "0.021 秒",
};

export default locale;
